var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isMaranhao
    ? _c(
        "div",
        [
          _c(
            "el-row",
            { staticClass: "caixa-pesquisa", attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                {
                  staticClass: "card-container",
                  staticStyle: { margin: "15px 0 20px 0" },
                  attrs: { shadow: "hover" }
                },
                [
                  _vm.opcoesAcoes && _vm.processo
                    ? _c("app-opcoes-header-analise", {
                        staticClass: "right",
                        attrs: {
                          idProcesso: _vm.idProcesso,
                          protocolo: _vm.numeroProtocolo,
                          statusProcesso: _vm.statusProcesso,
                          numeroProcesso: _vm.numeroProcesso,
                          tipoProcesso: _vm.tipoCodigoProcesso,
                          btnNotificarInteressado: false,
                          btnRetificacao: false,
                          btnSolicitarInformacao: false
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("h4", [
                    _vm._v("Núcleo ou Nome/razão social do interessado:")
                  ]),
                  _c("el-input", {
                    staticClass: "span-style",
                    attrs: {
                      type: "text",
                      value:
                        _vm.processo && _vm.processo.nomeRazaoSocialInteressado
                          ? _vm.processo.nomeRazaoSocialInteressado
                          : "",
                      disabled: true
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("h4", [_vm._v("CPF/CNPJ do Interessado:")]),
                  _c("el-input", {
                    staticClass: "span-style",
                    attrs: {
                      type: "text",
                      value:
                        _vm.processo && _vm.processo.cpfCnpjInteressado
                          ? _vm.processo.cpfCnpjInteressado
                          : "",
                      disabled: true
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("h4", [_vm._v("Tipo de Processo:")]),
                  _c("el-input", {
                    staticClass: "span-style",
                    attrs: {
                      type: "text",
                      value:
                        _vm.processo && _vm.processo.tipo.codigo
                          ? _vm.formatText(_vm.processo.tipo.codigo)
                          : "",
                      disabled: true
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("h4", [_vm._v("Setor:")]),
                  _c("el-input", {
                    staticClass: "span-style",
                    attrs: {
                      type: "text",
                      value:
                        _vm.processo && _vm.processo.setor
                          ? _vm.formatText(_vm.processo.setor)
                          : "",
                      disabled: true
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("h4", [_vm._v("Status:")]),
                  _c("el-input", {
                    staticClass: "span-style",
                    attrs: {
                      type: "text",
                      value:
                        _vm.processo && _vm.processo.status
                          ? _vm.formatText(_vm.processo.status)
                          : "",
                      disabled: true
                    }
                  })
                ],
                1
              ),
              _vm.processo &&
              _vm.processo.usuario &&
              _vm.processo.usuario.pessoa
                ? _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("h4", [_vm._v("Usuario:")]),
                      _c("el-input", {
                        staticClass: "span-style",
                        attrs: {
                          type: "text",
                          value:
                            _vm.processo &&
                            _vm.processo.usuario &&
                            _vm.processo.usuario.pessoa &&
                            _vm.processo.usuario.pessoa.nomeRazaoSocial
                              ? _vm.processo.usuario.pessoa.nomeRazaoSocial
                              : "",
                          disabled: true
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    : _c("div", { staticClass: "container-geral" }, [
        _c(
          "div",
          { staticClass: "opcoes-wrapper" },
          [
            _vm.opcoesAcoes && _vm.processo
              ? _c("app-opcoes-header-analise", {
                  attrs: {
                    idProcesso: _vm.idProcesso,
                    protocolo: _vm.numeroProtocolo,
                    statusProcesso: _vm.statusProcesso,
                    numeroProcesso: _vm.numeroProcesso,
                    tipoProcesso: _vm.tipoCodigoProcesso,
                    btnNotificarInteressado: false,
                    btnRetificacao: false,
                    btnSolicitarInformacao: false
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "center" },
          [
            _c(
              "el-col",
              { staticClass: "flex", attrs: { span: 8 } },
              [
                _c("app-display", {
                  attrs: {
                    label: "Nome do Interessado:",
                    content: _vm.processo.nomeRazaoSocialInteressado
                  }
                }),
                _c("app-display", {
                  attrs: {
                    label: "CPF/CNPJ:",
                    content: _vm.processo.cpfCnpjInteressado
                  }
                })
              ],
              1
            ),
            _c(
              "el-col",
              { staticClass: "flex", attrs: { span: 8 } },
              [
                _c("app-display", {
                  attrs: {
                    label: "Tipo de processo:",
                    content: _vm.processo.tipo.nome
                  }
                }),
                _c("app-display", {
                  attrs: {
                    label: "Município:",
                    content: _vm.processo.municipios[0].nome
                  }
                })
              ],
              1
            ),
            _c(
              "el-col",
              { staticClass: "flex", attrs: { span: 8 } },
              [
                _c("app-display", {
                  attrs: {
                    label: "Setor:",
                    content: _vm.formatText(_vm.processo.setor)
                  }
                }),
                _c("app-display", {
                  attrs: {
                    label: "Status:",
                    content: _vm.formatText(_vm.processo.status)
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3839ba3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3839ba3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/manutencao/components/CardMoverProcessos.vue
// module id = null
// module chunks = 